// React
import React, { Component } from 'react'
import PropTypes from 'prop-types'

// Libraries

// Components
import Sidebar from '../Sidebar'
import { CartPickerButton } from 'store/modules/cart/CartPicker/Button'
import { PoweredBy } from 'shop-components/components/PoweredBy'
import Lines from './Lines'
import Spacer from 'ui/blocks/Spacer'

// Shared

export class EmbeddableCartMobile extends Component {
  static displayName = 'EmbeddableCartMobile'

  static propTypes = {
    showPoweredBy: PropTypes.bool,
    t: PropTypes.func
  }

  render () {
    const { showPoweredBy } = this.props

    return (
      <div className="bq-cart bq-cart--mobile">
        <CartPickerButton />
        <div className="booqable-component" style={{ display: 'none' }}>
          <hr />
          <Lines />
          <Sidebar datepicker={false} />
          <Spacer size="md" vertical />
          {showPoweredBy && (
            <div className="bq-poweredby">
              <PoweredBy logoWidth="16px" />
            </div>
          )}
        </div>
      </div>
    )
  }
}

export default EmbeddableCartMobile
